import { Point } from "../../Utils/Point";
import { AbstractBgTileContainerModel } from "./AbstractBgTileContainerModel";
import { BgBackCityTileModel } from "./TileModels/BgBackCityTileModel";

export class BgBackCityTileContainerModel extends AbstractBgTileContainerModel<BgBackCityTileModel>{
    public tiles: BgBackCityTileModel[] = [];
    public speed: number = 30;

    constructor() {
        super();
        this._createTiles(3);
    }

    protected _createTile(): BgBackCityTileModel {
        return new BgBackCityTileModel();
    }
}